import React from 'react';
import styles from './Modal.module.css';

export interface ModalProps {
    children: React.ReactNode;
    onClose: () => void;
    visible: boolean;
}

const Modal = ({
                     children,
                     onClose,
                     visible,
                 }: ModalProps) => {
    if (!visible) {
        return null;
    }

    return (
        <div className={styles.container}>
            <div className={styles.background} onClick={onClose}/>
            <div className={styles.wrapper}>
                <div className={styles.close} onClick={onClose}/>

                {children}

            </div>
        </div>
    );
};

export default Modal;
